module.exports = __webpack_public_path__ + "img/hr-heat-pipe-corner-up-right-5.67c1608d.png";